import React from 'react';
import '../components-css/about-me.scss'
import MiniHeaders from "./mini-headers";
import {lecturer} from "../data/mock-date";

const AboutMe = () => {
    return (
        <div className={'blocks-wrapper'}>
            <MiniHeaders headerName={'Միլենա Մելիքսեթյանի մասին'} fontSize={22}/>
            <ul>
                {lecturer.map((item, index) => (
                    <li key={index} className="list-item">
                        <p>{item}</p>
                    </li>
                ))}
            </ul>
            <div className={'about-me-img'}/>
        </div>
    );
};

export default AboutMe;
